<template>
    <div>
        <page-title :title="$t('annualCatalog.annualCatalogProject')" :showTitle="false"></page-title>
        <div class="card mx-auto mt-2 px-0">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">
                    {{ $t('annualCatalog.annualCatalogProject') }}
                </div>
            </div>

            <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                <div class="form-inline col-lg-6 col-md-12">

                </div>

                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input"
                           aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <div class="card-body">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>
                <kendo-grid ref="grid"
                            :height="600"
                            :data-source-ref="'datasource1'"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :dataBound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :title="$t('activity.id')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'year'"
                                       :title="$t('planning.year')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'date'"
                                       :format="'{0:dd-MM-yyyy}'"
                                       :title="$t('annualCatalog.createdDate')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'userName'"
                                       :title="$t('annualCatalog.createdUser')">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       v-if="showBtns">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import store from '../../store/store';
    import GridUserSettings from "../../components/grid/UserSettings";
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../components/common/PageTitle';
    import DatetimeCellDisplayTemplate from "../../components/grid/DatetimeCellDisplayTemplate";
    import { mapGetters } from 'vuex'

    export default {
        props: {
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showExportTemplateButton: {
                default: true,
                type: Boolean
            },
            showImportFromExcelButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            }
        },
        components: {
            PageTitle,
            'grid-user-settings': GridUserSettings,
        },
        data() {
            return {
                componentName: "annualcatalogproject",
                titleKey: 'activity.title',
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                searchQuery: '',
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'activity.id' },
                    year: { name: 'year', type: 'number', editable: false, nullable: false, visible: true, titleKey: 'planning.year' },
                    date: { name: 'date', type: 'date', editable: false, nullable: false, visible: true, titleKey: 'annualCatalog.createdDate' },
                    userName: { name: 'userName', type: 'string', editable: false, nullable: false, visible: true, titleKey: 'annualCatalog' }
                },
                rawHtml: "",
                transportSettings: {
                    read: {
                        url: `${store.getters.baseUrl}/api/AnnualCatalogProject/list`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                showUserSettingsForm: false,
                newDate: ''
            }
        },
        methods: {
            goToEdit(args) {
                this.$router.push('/annualCatalogProject/' + args.id);
            },
            dataBound(e) {
                this.loadColumnsVisibilitySettings();
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveState: function () {
                let grid = this.$refs.grid.kendoWidget();

                localStorage["audit-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["kendo-grid-options"];
                let grid = this.$refs.grid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            toolbarTemplate: function () {
                let templateHtml =
                    '<span>' +
                    '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
                    '</span>';

                return kendo.template(templateHtml);
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [
                            {
                                name: "edit",
                                text: "",
                                tooltip: this.$t('buttons.edit.tooltipText'),
                                class: 'btn btn-success',
                                icon: "fas fa-edit",
                                show: this.hasEditRights,
                                clickHandler: this.goToEdit
                            }
                        ]
                    }
                };
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            datetimeDisplayTemplate: function (e) {
                return this.newDate = {
                    template: Vue.component(DatetimeCellDisplayTemplate.name, DatetimeCellDisplayTemplate),
                    templateArgs: {
                        dateValue: e.date,
                        showShortDate: false
                    },
                };
            },
            gridSettingsChanged(componentName, name, value) {
                this.setColumnVisibilitySettings();
            },
            loadColumnsVisibilitySettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getColumnVisibility'
                ).then((response) => {
                    if (response.data.settings === null) {
                        return;
                    }

                    let settings = [];
                    for (var i = 0; i < response.data.settings.length; i++) {
                        settings.push(response.data.settings[i].name)
                    }
                    for (const key in this.schemaModelFields) {
                        if (this.schemaModelFields.hasOwnProperty(key)) {
                            this.schemaModelFields[key].visible = settings.includes(key);
                        }
                    }

                    this.setColumnVisibilitySettings();
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            setColumnVisibilitySettings() {
                var grid = this.$refs.grid.kendoWidget();
                var columns = grid.columns;

                // restore columns visibility state using the stored values
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (!column.field
                        || !this.schemaModelFields.hasOwnProperty(column.field)
                        || !this.schemaModelFields[column.field].hasOwnProperty('visible')) {
                        continue;
                    }

                    if (this.schemaModelFields[column.field].visible) {
                        grid.showColumn(column);
                    }
                    else {
                        grid.hideColumn(column);
                    }
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
            this.showSettingsBtn = false;
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return store.getters.authToken;
            },
            hasEditRights() {
                return this.$store.getters.claims.annualCatalogProject.create
                    || this.$store.getters.claims.annualCatalogProject.update;
            }
        }
    }
</script>

<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>

